import { AlphaBBoxOutlineIcon } from './AlphaBBoxOutlineIcon';

/**
 * author: Contributors
 * id ACEAA38C-D83E-4812-AFF3-A063F0226825
 * name alpha-b-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-b-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetBBoxOutlineIcon = AlphaBBoxOutlineIcon;
export default AlphabetBBoxOutlineIcon